import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/purchase-orders",
      params: { goodsReceiptId: params.goodsReceiptId },
    })
  },
})
